var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgApple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "apple account connect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.292969,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#1F408C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4642 8.29297C20.506 8.29297 20.5479 8.29297 20.5922 8.29297C20.695 9.56237 20.2104 10.5109 19.6216 11.1977C19.0438 11.8798 18.2526 12.5414 16.9729 12.441C16.8876 11.1898 17.3729 10.3117 17.9609 9.62639C18.5063 8.98774 19.5062 8.41943 20.4642 8.29297Z",
    fill: "#4987FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3373 21.5048C24.3373 21.5174 24.3373 21.5285 24.3373 21.5403C23.9777 22.6295 23.4647 23.563 22.8387 24.4293C22.2673 25.2157 21.567 26.2741 20.3165 26.2741C19.236 26.2741 18.5183 25.5793 17.411 25.5604C16.2396 25.5414 15.5954 26.1413 14.5244 26.2923C14.4019 26.2923 14.2794 26.2923 14.1592 26.2923C13.3728 26.1785 12.7381 25.5556 12.2757 24.9944C10.9122 23.3361 9.85862 21.1941 9.6626 18.453C9.6626 18.1843 9.6626 17.9163 9.6626 17.6476C9.74559 15.6858 10.6988 14.0907 11.9659 13.3177C12.6345 12.9067 13.5538 12.5565 14.5774 12.713C15.016 12.781 15.4642 12.9312 15.857 13.0798C16.2293 13.2229 16.6949 13.4766 17.1359 13.4631C17.4347 13.4544 17.7319 13.2987 18.033 13.1889C18.9151 12.8703 19.7798 12.5052 20.9196 12.6767C22.2894 12.8838 23.2616 13.4924 23.8623 14.4314C22.7036 15.1688 21.7875 16.2802 21.944 18.1779C22.0831 19.9018 23.0853 20.9104 24.3373 21.5048Z",
    fill: "#4987FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgApple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/apple.8693f2f1409d0fb77776a04a1f461c2b.svg";